<template>
  <v-dialog v-model='dialog' max-width='500px'>
    <v-card>
      <v-card-title class='headline font-weight-regular oem-color'>
        Legend
      </v-card-title>
      <v-card-text>
        <div v-for='(state, index) in states'
          :key='index'
        >
          <v-btn icon :disabled='true'>
            <selector
              :index='index'
              :disabled='true'
              :state='state'
              :text='text[index]'
            ></selector>
          </v-btn>
          {{ legend[index] }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class='oem-button' flat @click='dialog = false'>
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import selector from './BaseSelector.vue';

export default {
  name: 'helpLegend',
  props: {
    page: String,
  },
  components: {
    selector,
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    legend() {
      if (this.page === 'pulse') {
        return [
          'Active',
          'Unused',
        ];
      }
      if (this.page === 'CT') {
        return [
          'Fully configured',
          `Assigned to load, but ${this.page} not configured`,
          `CT configured, but ${this.page} not assigned to load`,
          'Unused',
          `Number indicates ${this.page} number`,
        ];
      }
      if (this.page === 'input') {
        return [
          'Fully configured',
          `Assigned to load, but ${this.page} not configured`,
          `Input configured, but ${this.page} not assigned to load`,
          'Unused',
          `Number indicates ${this.page} number`,
        ];
      }
      if (this.page === 'systemlog') {
        return [
          'Emergency, Alert, Critical or Error',
          'Warning',
          'Info or Debug',
        ];
      }
      return [
        'Fully configured',
        'Assigned to load, but CT not configured',
        'CT configured, but CT not assigned to load',
        'Unused',
        'Number indicates load number',
      ];
    },
    states() {
      if (this.page === 'pulse') {
        return [0, 3];
      }
      if (this.page === 'CT' || this.page === 'input') {
        return [0, 1, 2, 3, 3];
      }
      if (this.page === 'systemlog') {
        return [1, 4, 3];
      }
      return [0, 1, 2, 3, 3];
    },
    text() {
      if (this.page === 'CT') {
        return ['', '', '', '', '1'];
      }
      if (this.page === 'input') {
        return ['', '', '', '', '1'];
      }
      if (this.page === 'systemlog') {
        return ['', '', ''];
      }
      return ['', '', '', '', '1'];
    },
  },
  methods: {
    show() {
      this.dialog = true;
    },
  },
};
</script>
